module.exports = __webpack_public_path__ + "static/banner_hero-image2-51e69127ce3a402ec1a153f367969cf6.png";